import '../world-clock/timezone-data.js';
import { initWorldClock } from '../world-clock/world-clock.js';

class WorldPageModule {
  constructor() {
    this.clockInstance = null;
  }

  ensureClock(app) {
    if (!this.clockInstance) {
      this.clockInstance = initWorldClock();
      if (this.clockInstance && app && typeof app.setWorldClockInstance === 'function') {
        app.setWorldClockInstance(this.clockInstance);
      }
    }
    return this.clockInstance;
  }

  ensureSettingsManager() {
    return null;
  }

  openSettings() {
    return null;
  }
}

function registerModule() {
  const app = window.digitalClockApp;
  if (!app || typeof app.registerPageModule !== 'function') {
    return;
  }
  const pageType = app.pageType || document.body?.dataset?.pageType;
  if (pageType !== 'world') {
    // 仅在世界时钟页面注册模块
    return;
  }
  const module = new WorldPageModule();
  app.registerPageModule('world', module);
  module.ensureClock(app);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', registerModule);
} else {
  registerModule();
}
